module.exports = __webpack_public_path__ + "static/media/027.276545bc.png";